import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'components/core/Image';
import './FramedImage.scss';

export default function FramedImage({ src, alt = '', className }) {
	return (
		<div className="framed-image">
			<Image
				className={className}
				src={src}
				alt={alt}
				lazyload={false}
				// fetchPriority="high" TODO: to Improve LCP
				width={480}
				height={560}
			/>

			<svg
				className="outline outline-1"
				viewBox="0 0 480 560"
				preserveAspectRatio="none"
			>
				<rect
					x="0"
					y="0"
					width="100%"
					height="100%"
					rx="4"
					ry="4"
					stroke="rgba(41, 216, 255, 1)"
					strokeWidth="2"
					fill="none"
				/>
			</svg>

			<svg
				className="outline outline-2"
				viewBox="0 0 480 560"
				preserveAspectRatio="none"
			>
				<rect
					x="0"
					y="0"
					width="100%"
					height="100%"
					rx="4"
					ry="4"
					stroke="rgba(41, 216, 255, 1)"
					strokeWidth="2"
					fill="none"
				/>
			</svg>
		</div>
	);
}

FramedImage.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
	className: PropTypes.string,
};
